import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/features/identity/services/auth.api";

export function useResendOtp() {
  return useMutation({
    mutationFn: authApi.resendOtp,
  });
}
